// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"7a4a18de","946":"da256312"}[chunkId] + ".chunk.js";
};